import React from 'react';
import { useAuth } from '../context/AuthContext';
import { AlertTriangle, CreditCard } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SubscriptionBanner = () => {
  const { hasRestrictedAccess, subscription } = useAuth();
  const navigate = useNavigate();
  
  // Check access after all hooks
  const hasRestriction = hasRestrictedAccess();
  
  if (!hasRestriction) return null;

  const handleManageSubscription = () => {
    navigate('/profile/edit?tab=subscription');
  };

  return (
    <div className="bg-orange-50 border-l-4 border-orange-400 p-4 mb-4">
      <div className="flex items-center">
        <AlertTriangle className="h-5 w-5 text-orange-400 mr-3" />
        <div className="flex-1">
          <h3 className="text-sm font-medium text-orange-800">
            Subscription Paused
          </h3>
          <p className="mt-1 text-sm text-orange-700">
            Your subscription is currently paused. You have limited access to the platform.
            You can still access your profile, community circles, and explore community pages.
          </p>
        </div>
        <button
          onClick={handleManageSubscription}
          className="ml-4 flex items-center px-3 py-2 bg-orange-600 text-white text-sm rounded-md hover:bg-orange-700 transition-colors"
        >
          <CreditCard className="h-4 w-4 mr-2" />
          Manage Subscription
        </button>
      </div>
    </div>
  );
};

export default SubscriptionBanner;